import { utils_api } from 'generics/common';

export class SettingsInjections {

  static getUsedCircuit() {
    return utils_api.frozenMerge(SettingsInjections._circuit);
  }


  static getUsedCircuitName() {
    return SettingsInjections._circuitName;
  }


  static getUsedLocale() {
    //  HINT: its defaulting, not merging!
    return utils_api.frozenMerge(SettingsInjections._Locale ||
      { name: "english", code: "en_US", icon: "en", enabled: true });
  }

  static getCredentials() {
    return utils_api.frozenMerge(
      { token: '', userId: 0, nick: '' },
      SettingsInjections._creds
    );
  }

  static getGamesList() {
    return SettingsInjections._games;
  }


  static setCredentials(creds) {
    SettingsInjections._creds = Object.assign({}, creds);
  }

  static getVersion() {
    return "@@BUILDSTAMPMARK@@";
  }

  static getMode() {
    return process.env.REACT_APP_ACHIEVEMENT_MODE || 'default';
  }

  static getLoginHost() {
    return process.env.REACT_APP_LOGIN_HOST || '';
  }

  static getLegalHost() {
    return process.env.REACT_APP_LEGAL_HOST || '';
  }
}